import { render } from "./JustoppMobileFooter.vue?vue&type=template&id=3a709faa&scoped=true"
import script from "./JustoppMobileFooter.vue?vue&type=script&lang=js"
export * from "./JustoppMobileFooter.vue?vue&type=script&lang=js"

import "./JustoppMobileFooter.vue?vue&type=style&index=0&id=3a709faa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a709faa"]])

export default __exports__